import React from 'react';
import { useParams } from 'react-router-dom';
import BookingPageContent from './content';
import { PageContextProvider } from './context';

const BookingPage = () => {
  const { virtualPhoneNumber, serviceId } = useParams();

  return (
    <PageContextProvider virtualPhoneNumber={virtualPhoneNumber} serviceId={serviceId}>
      <BookingPageContent />
    </PageContextProvider>
  );
};

export default BookingPage;
